

import { Injectable } from '@angular/core';
import {HttpService} from './http.service';
import {Observable} from 'rxjs';
import {environment} from "@shared-environments/environment";

@Injectable()
export class DisputeService {

  private getOneByIdUrl = '/dispute/one/:disputesId';
  private addUrl = '/dispute/';

  ////

  constructor(private networkHelper: HttpService) {
  }

  getOneById(disputesId: string): Observable<any> {
    return this.networkHelper.get(environment.apiURL +
      this.getOneByIdUrl.replace(':disputesId', disputesId));
  }
  add(data: object): Observable<any> {
    return this.networkHelper.post(environment.apiURL +
      this.addUrl,data);
  }
}



